'use strict';

import * as d3 from 'd3';

export const ellipsisText = (text, width, xOffset) => {
  text.each(function () {
    const text = d3.select(this);
    const words = text.text().split(/\s+/);
    const ellipsis = text
      .text('')
      .append('tspan')
      .attr('class', 'elip')
      .text('...');
    if (xOffset !== undefined) { ellipsis.attr('transform', () => xOffset ? `translate(${xOffset}, 0)` : null); }
    const availableWidth = width - ellipsis.node().getComputedTextLength();
    const numWords = words.length;
    const tspan = text.insert('tspan', ':first-child').text(words.join(' '));

    // Try the whole line
    // While it's too long, and we have words left, keep removing words
    while (tspan.node().getComputedTextLength() > availableWidth && words.length) {
      words.pop();
      tspan.text(words.join(' '));
    }

    if (words.length === numWords) {
      ellipsis.remove();
    }
  });
};

export const wrapText = (texts, width, options = { x: undefined }) => {
  texts.each(function () {
    const text = d3.select(this);
    const words = text.text().split(/\s+/).reverse();
    // let lineNumber = 0;
    const lineHeight = 1.1; // ems
    const x = options.x === undefined ? text.attr('x') : options.x;
    // const y = text.attr('y');
    const dy = 0; // parseFloat(text.attr("dy")),
    let tspan = text.text(null)
      .append('tspan')
      .attr('x', x)
      // .attr('y', y)
      .attr('dy', dy + 'em');
    const widthValue = typeof width === 'string'
      ? text.attr(width)
      : width;
    let line = [];
    let word;
    while ((word = words.pop())) {
      line.push(word);
      tspan.text(line.join(' '));
      if (tspan.node().getComputedTextLength() > widthValue) {
        line.pop();
        tspan.text(line.join(' '));
        line = [word];
        tspan = text.append('tspan')
          .attr('x', x)
          // .attr('y', y)
          // .attr('dy', ++lineNumber * lineHeight + dy + 'em')
          .attr('dy', lineHeight + dy + 'em')
          .text(word);
      }
    }
  });
};

export const escapeSpecialChars = (jsonString) => {
  let output = jsonString.replaceAll('\n', '^^n');
  output = output.replaceAll('\r', '^^r');
  return output;
};

const Utils = {
  ellipsisText: ellipsisText,
  escapeSpecialChars: escapeSpecialChars,
  wrapText: wrapText
};

export default Utils;
